export function matchesSearch(term, values) {
  const t = String(term || "").trim().toLowerCase();
  if (!t) return true;
  const list = Array.isArray(values) ? values : [];
  return list.some((value) => (value || "").toString().toLowerCase().includes(t));
}

const BLANK_FILTER_ID = "__none";
const DEFAULT_BLANK_LABEL = "(Blank)";

export function buildFilterOptions(items, { getId, getLabel, blankLabel = DEFAULT_BLANK_LABEL } = {}) {
  const list = Array.isArray(items) ? items : [];
  const unique = new Map();
  let includeBlank = false;

  list.forEach((item) => {
    const rawId = getId ? getId(item) : null;
    if (rawId === null || rawId === undefined) {
      includeBlank = true;
      return;
    }
    const id = String(rawId);
    if (unique.has(id)) return;
    const labelRaw = getLabel ? getLabel(item) : "";
    const label = (labelRaw || "").toString().trim() || id;
    unique.set(id, { id, label });
  });

  if (includeBlank) {
    unique.set(BLANK_FILTER_ID, { id: BLANK_FILTER_ID, label: blankLabel });
  }

  return Array.from(unique.values()).sort((a, b) =>
    a.label.localeCompare(b.label, undefined, { sensitivity: "base" }),
  );
}

export function pruneSelectedFilters(selectedIds, options) {
  const selected = Array.isArray(selectedIds) ? selectedIds : [];
  const opts = Array.isArray(options) ? options : [];
  if (!selected.length) return selected;
  const allowed = new Set(opts.map((opt) => opt.id));
  const next = selected.filter((id) => allowed.has(id));
  return next.length === selected.length ? selected : next;
}

export function filterByClientProject({
  items,
  term,
  clientFilters,
  brandFilters,
  projectFilters,
  getClientId,
  getBrandId,
  getProjectId,
  getSearchValues,
} = {}) {
  const list = Array.isArray(items) ? items : [];
  const t = String(term || "").trim().toLowerCase();
  const clientSet = new Set(Array.isArray(clientFilters) ? clientFilters : []);
  const brandSet = new Set(Array.isArray(brandFilters) ? brandFilters : []);
  const projectSet = new Set(Array.isArray(projectFilters) ? projectFilters : []);
  const includeBlankClient = clientSet.has(BLANK_FILTER_ID);
  const includeBlankBrand = brandSet.has(BLANK_FILTER_ID);
  const includeBlankProject = projectSet.has(BLANK_FILTER_ID);

  return list.filter((item) => {
    const rawProject = getProjectId ? getProjectId(item) : item?.projectId;
    const rawBrand =
      getBrandId ? getBrandId(item) : item?.brandId ?? item?.brandName;
    const rawClient = getClientId ? getClientId(item) : item?.clientId;

    const projectId =
      rawProject === null || rawProject === undefined ? null : String(rawProject);
    const brandId =
      rawBrand === null || rawBrand === undefined ? null : String(rawBrand);
    const clientId =
      rawClient === null || rawClient === undefined ? null : String(rawClient);

    if (projectSet.size > 0) {
      if (projectId === null) {
        if (!includeBlankProject) return false;
      } else if (!projectSet.has(projectId)) {
        return false;
      }
    }

    if (brandSet.size > 0) {
      if (brandId === null) {
        if (!includeBlankBrand) return false;
      } else if (!brandSet.has(brandId)) {
        return false;
      }
    }

    if (clientSet.size > 0) {
      if (clientId === null) {
        if (!includeBlankClient) return false;
      } else if (!clientSet.has(clientId)) {
        return false;
      }
    }

    if (!t) return true;
    const values = getSearchValues ? getSearchValues(item) : [];
    return values.some((value) => (value || "").toString().toLowerCase().includes(t));
  });
}
